import glamorous from 'glamorous';
import React from 'react';
import { createPureComponent } from 'module/Common';
import { LocalizedContent, Sizes, BrandonGrotesque } from 'module/View/Common';
import { Post } from 'module/Model/Post';

const lineHeight = 1.3;

const Wrapper = glamorous.h1({
  position: 'absolute',
  right: Sizes.gutter,
  textAlign: 'left',
  paddingRight: '200px',
  fontSize: Math.floor(Sizes.bigTitleLineHeght / lineHeight) + 'px',
  lineHeight: Sizes.bigTitleLineHeght + 'px',
  fontFamily: BrandonGrotesque.medium,
  fontStyle: 'normal',
  fontWeight: 'normal',
  zIndex: 750,
});

const Line = glamorous.span({
  display: 'block',
});

type Props = {
  post: Post;
  linesRefs: Array<(elem: HTMLElement | null) => void>;
};

export const PostBigTitle = createPureComponent<Props>('PostBigTitle', ({ post, linesRefs }) => {
  if (post.titleLines.length !== linesRefs.length) {
    console.warn('Incoherence !!');
  }
  return (
    <Wrapper>
      {post.titleLines.map((line, index) => (
        <LocalizedContent key={index} content={line}>
          {content => <Line innerRef={linesRefs[index]}>{content}</Line>}
        </LocalizedContent>
      ))}
    </Wrapper>
  );
});



// WEBPACK FOOTER //
// ./src/module/View/Publication/PostBigTitle.tsx